import { ProjectCollateralCategory } from '../_project_types/projectCollateralCategory'

export const colorByCollateralCategory = {
  [ProjectCollateralCategory.Commercial]: '#7A5200',
  [ProjectCollateralCategory.Land]: '#297A00',
  [ProjectCollateralCategory.Other]: '#3D007A',
  [ProjectCollateralCategory.Recreational]: '#00387A',
  [ProjectCollateralCategory.Residential]: '#7A0014',
}
